import { createAction, props } from '@ngrx/store';

export const loadPartnersCatalogSuccessByKey = createAction(
  '[PartnersCatalog] Load Success By Key',
  props<{ key: string; response: any }>(),
);
